var a = /* @__PURE__ */ ((l) => (l.small = "small", l.normal = "normal", l))(a || {});
const r = {
  small: 16,
  normal: 24
};
export {
  r as IconSizeMap,
  a as IconSizes
};
